import { AutoComplete, Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountService } from "../../services/account/AccountService";
import { handleError } from "../../utils/ErrorHandlers";
import AccountsList from "../accounts/AccountsList";
import Page from "../general/Page";
import history from "../../utils/history";
import "./Accounts.css";
import { Translation } from "react-i18next";

import AuthorizedOnly from "../general/AuthorizedOnly";

class Accounts extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("accounts");
    this.state = {
      isFetching: false,
      data: [],
      // cfgData: [],
      visible: false,
      loading: false,
      groupAccount: {
        accountId: "ACC.190109.154320.0000001",
        groupName: "delete",
        groupType: "IBG",
        cfg: [
          {
            key: "CALL_FLOW",
            value: "dv1",
            configCategory: "CALL_FLOW",
          },
        ],
      },
    };
  }

  componentDidMount() {
    this.getAllAccountsService();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }
  async getAllAccountsService() {
    try {
      this.acc = new AccountService();
      this.setState({ isFetching: true });
      let data = await this.acc.getAllAccountsService(
        this.props.context.session_id
      );
      // if(data.ivrList.size>0){
      // this.setState({
      //   data: data.ivrList,
      //   isFetching: false,
      //   cfgData: data.cfgList,
      // });

      this.accountDataAndCfgMapping(data.ivrList, data.cfgList);
    } catch (e) {
      this.setState({ isFetching: false });

      handleError(e);
    }
  }
  addNewAccount = () => {
    history.push("/home/accounts/create");
  };

  cfgFormatting(cfgfiltered) {
    // change the formatting of property
    let cfgFormatted = {};
    cfgFormatted.pkg_name = "";
    cfgFormatted.accountId = "";
    cfgFormatted.configCategory = "";
    cfgFormatted.agents_max_num = "";
    cfgFormatted.max_concurrent_calls = "";
    cfgFormatted.account_numbers = [];
    cfgfiltered.forEach((el, index) => {
      if (el.key === "PKG_NAME") {
        cfgFormatted.pkg_name = el.value;
        cfgFormatted.accountId = el.accountID;
        cfgFormatted.configCategory = el.configCategory;
      }
      if (el.key === "AGENTS_MAX_NUMBER") {
        cfgFormatted.agents_max_num = el.value;
        cfgFormatted.accountId = el.accountID;
        cfgFormatted.configCategory = el.configCategory;
      }
      if (el.key === "MAX_CONCURRENT_CALLS") {
        cfgFormatted.max_concurrent_calls = el.value;
        cfgFormatted.accountId = el.accountID;
        cfgFormatted.configCategory = el.configCategory;
      }
      if (el.key === "ACCOUNT_NUMBERS") {
        cfgFormatted.account_numbers = el.value.split(",");

        cfgFormatted.accountId = el.accountID;
        cfgFormatted.configCategory = el.configCategory;
      }
    });
    return cfgFormatted;
  }

  accountDataAndCfgMapping(data, cfgData) {
    // let { data, cfgData } = this.state;

    //get an array of data and cfg
    data.forEach((element, index) => {
      let cfgtest = cfgData.filter(
        (cfgEl) => element.accountId === cfgEl.accountID
      );
      data[index].cfg = this.cfgFormatting(cfgtest);
    });

    this.setState({ data: data, isFetching: false });
  }

  handleOk = (e) => {
    e.preventDefault();
    let { updateUser, updateSession, updateDefaultTree } = this.props.context;
    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          await this.createAccount(values);
          this.setState({
            visible: false,
          });
          this.setState({ loading: false });
          this.props.form.resetFields();
          this.getAllAccountsService();
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;

    let data = this.state.data;

    let { isFetching } = this.state;

    return (
      <Translation>
        {(t) => (
          <Page title={t("Accounts")}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <AuthorizedOnly privileges={["CREATE.ACCOUNT"]}>
                  <Button
                    className="button-add-account"
                    onClick={this.addNewAccount}
                    icon="plus"
                  />
                  <span>{t("Add New Account")}</span>
                </AuthorizedOnly>
                <AccountsList
                  data={this.state.data}
                  onRefresh={() => this.getAllAccountsService()}
                ></AccountsList>
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(withSharedStateConsumer(withRouter(Accounts)));
